import appConfig from '@/common/appConfig';
import { APP_THEME_MAP } from '@/common/constants/themes.constants';

const TELEMETRY_ENABLED_ENVIRONMENTS = ['production', 'playwright'];

export const isTelemetryEnvironmentEnabled = (): boolean => {
  if (!appConfig.app_env || !TELEMETRY_ENABLED_ENVIRONMENTS.includes(appConfig.app_env)) {
    return false;
  }

  return process.env.APP_THEME !== APP_THEME_MAP.acronis;
};

export const isAutotestEnvironment = (): boolean => appConfig.app_env
    ? ['testcafe', 'playwright'].includes(appConfig.app_env)
    : false;
